<template>
    <div class="pickQu">
        <el-container>      
      <el-main>
        <el-row>
          <h1 :style="{fontSize:'3vh',color:'#303133'}">请选择区域</h1>
        </el-row>

       <el-row :style="{marginTop:'10vh'}" v-if="quObj!=null && stepNum == 1">
           <el-col :span="12" :offset="6">
               <el-tree
                ref="tree"
                show-checkbox
                :data="quObj"
                node-key="id"
                @check-change="handleCheckChange">
               </el-tree>
           </el-col>
       </el-row>
       <el-row v-if="stepNum == 2">
           
       </el-row>
      </el-main>
    </el-container>
    </div>
</template>
<style scoped>

</style>
<script>
import axios from "axios"

export default {
   data(){
        return{
            shopList:new Object,
            apiPath : "https://yygj.darenlaiye.com/drzf/wj.aspx",
            quObj:new Array,
            stepNum:1,
        }
    },
    mounted(){
        var that = this;
        axios.get(this.apiPath,{params:{
            task:"getCSQu"
        }}).then(function(res){
            console.log(res.data.data)
            that.quObj = res.data.data;
        });
    },
    methods:{
        loadShopList(){
            //axios.get
        },
        handleCheckChange(data, checked, indeterminate) {
            let res = this.$refs.tree.getCheckedNodes()
            let arr = []
            res.forEach((item) => {
                arr.push(item.id)
            })
            console.log(arr);
        },
    }
}
</script>